import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import UILink from 'UIComponents/link/UILink';
import Alert from 'developer-docs-mdx-components/components/Alert';
import styled from 'styled-components';
import { getEnglishSearchResultsUrl } from '../../utils/urls';
import { ALERT_CONTAINER_MAX_WIDTH } from './constants';
import { jsx as _jsx } from "react/jsx-runtime";
const AlertContainer = styled.div.withConfig({
  displayName: "SeeEnglishResults__AlertContainer",
  componentId: "yt3it1-0"
})(["max-width:", "px;"], ALERT_CONTAINER_MAX_WIDTH);
export const SeeEnglishResults = ({
  query
}) => {
  return /*#__PURE__*/_jsx(AlertContainer, {
    children: /*#__PURE__*/_jsx(Alert, {
      type: "info",
      children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "developer-docs-ui.search.alertNotAllResultsAreTranslated_jsx",
        elements: {
          Link: UILink
        },
        options: {
          linkProps: {
            href: getEnglishSearchResultsUrl(query),
            external: true,
            hrefLang: 'en-us'
          }
        }
      })
    })
  });
};